import { defineAction } from '~/prix'
import questionnaireSaveAnswersAction from './questionnaireSaveAnswers.action.json' with { type: 'json' }
import { answerObject } from '../questionnaireObject'
import { z } from 'zod'

const questionnaireSaveAnswersDefinition = defineAction({
  ...questionnaireSaveAnswersAction,
  input: z.object({
    id: z.string().describe('ID para folha de respostas').nonempty(),
    originalLocalId: z.string().describe('ID do local de origem').default(''),
    citizenCpf: z.string().describe('CPF do cidadão').nullish(),
    citizenCns: z.string().describe('CNS do cidadão').nullish(),
    answers: z.array(answerObject),
    // hash: string().label('Hash do questionário'),
  }),
  output: z.object({
    answersSent: z.array(answerObject).describe('Respostas Enviadas'),
    answerSheetId: z.number().describe('ID da folha de respostas'),
  }),
})

export default questionnaireSaveAnswersDefinition
